// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"article-hero_wrapper__TJd7M","has-image":"article-hero_has-image__p5Cjf","has-video":"article-hero_has-video__QuEdh"};